import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryGridAr from "../components/EntryGridAr";
import EntrySetting from "../components/EntrySetting";
import EntryRemarks from "../components/EntryRemarks";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import EntryBase from "../components/EntryBase";
import DropZone from "../components/DropZone";
import Headline from "../components/Headline";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import {
    isEmpty, getglobaldata, NumConv, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid, getcontroller,
    getsubkey, initializedata, isEnabled, DicVal, Loadstorage
} from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup } from '../modules/toolpanelstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const DeliveryDtl = props => {

    const panelsdef = [];
    const G_id = { BASE: "0", RAW:"1", TOTAL:"T1", IMAGE: "pic", FILE: "file", NB: "nb", PL: "pl" }
    const primarykeys = ["NMD_DENNO"];
    const TRANTYPE = { NONE: "0", PROG: "1" }

    const formid = getformid("DeliveryDtl", props.location.search);
    const controller = getcontroller("DeliveryDtl", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);

    const AGRef = useRef();
    const fnc = useRef();
    const baseref = useRef();
    const EntrybodyRef = useRef(null);
    const locationstate = useRef(null);    //遷移State
    const transinfo = useRef(null);    //遷移情報

    const formstatus = useSelector(state => state.form.status);
    const entrylock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [update, setUpdata] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);
    const gridlist = useSelector(state => state.form.gridlist);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const initializeRef = useRef(false);

    const gridapiRefs = useRef([]);
    const gridcolapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);

    //データ
    const entrydataRef = useRef(null);
    const imageRef = useRef(null);
    const fileRef = useRef(null);         //ファイル  

    function SetGridData(panel, data) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        griddataRefs.current[gidx].current = data;
    }
    function GridData(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return griddataRefs.current[gidx].current;
    }
    function SetGridColDef(panel, coldef) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolRefs.current[gidx].current = coldef;
    }
    function GridColDef(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        return gridcolRefs.current[gidx].current;
    }
    function SetGridApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridapiRefs.current[gidx].current = api;
    }
    function GridApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridapiRefs.current[gidx].current;
    }
    function SetGridColApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolapiRefs.current[gidx].current = api;
    }
    function GridColApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridcolapiRefs.current[gidx].current;
    }

    //AGGridカラムの表示/非表示
    function SetGridColumnHide(columnid, hide) {
        const rawApi = GridApi(G_id.RAW);
        if (isEmpty(rawApi)) return;
        rawApi.setColumnsVisible([columnid], !hide);
    }
    function ApplySyusakiLayout() {
        if (isEmpty(entrydataRef.current)) return;

        const isStoreDirect = DicVal(entrydataRef.current, "NMD_SYUSAKIKBN") === "4";   //true:店舗
        SetGridColumnHide("NMM_LOT", isStoreDirect);
        SetGridColumnHide("NMM_SYUSAKICD", !isStoreDirect);
        SetGridColumnHide("SHDTH_HAIBUNSU", !isStoreDirect);

        cellHidden(["NMD_SYUSAKICD"], isStoreDirect);

        const coldef = GridColDef(G_id.TOTAL);
        if (isEmpty(coldef)) return;

        const qty1 = coldef.find(e => e.field === "QTY_T1");
        const qty2 = coldef.find(e => e.field === "QTY_T2");
        if (!isEmpty(qty1)) qty1.headerName = isStoreDirect ? "発注数合計" : "ロット合計";
        if (!isEmpty(qty2)) qty2.headerName = isStoreDirect ? "配分数合計" : "発注数合計";


        const totalApi = GridApi(G_id.TOTAL);
        if (!isEmpty(totalApi)) {
            totalApi.refreshHeader();
        }
    }

    const actionurl = {
        "delete": "DeliveryDtl/Delete",
        "getlist": "DeliveryDtl/GetListData",
    }

    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "print", icon: "print", label: "納品明細書発行" },
        { status: "ENTRY FORM", menuid: "fix", icon: "check", label: "確定" },
        { status: "ENTRY FORM", menuid: "fixcancel", icon: "cancel", label: "確定取消" },
        { status: "ENTRY FORM", menuid: "sep" },
        { status: "ENTRY FORM", menuid: "print", icon: "print", label: "納品明細書発行" },
    ]

    //動作抑止
    const suppressaction = [
        { type: "0", action: "INSERT" },
        { type: "0", action: "UPDATE" },
        { type: "0", action: "NEW FORM" },
    ];

    function rerender() {
        setUpdata(update ? false : true);
    }
    function onDragEnter(e) {
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };

    //主キー取得
    function primarykey() {
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.primarykey)) return "";
        return columninfo.find(e => e.primarykey).columnid;
    }
    //項目名取得
    function nametocolumn(name) {
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.columnid.indexOf(name) !== -1)) return "";
        return columninfo.find(e => e.columnid.indexOf(name) !== -1).columnid;
    }

    function setnavmenu(fixed, calcelfixshow) {
        var newmenu = navmenu;
        var hidemenu = null;
        if (fixed) { //確定済または赤伝または元黒伝
            hidemenu = [{ status : "ENTRY FORM", cmd : "登録" }];
            if (calcelfixshow) newmenu = navmenu.filter(e => e.status === "ENTRY FORM" && e.menuid !== 'fix');
            else newmenu = navmenu.filter(e => e.status === "ENTRY FORM" && e.menuid !== 'fix' && e.menuid !== 'fixcancel');
        } else {                                                    //未確定
            newmenu = navmenu.filter(e => e.status === "ENTRY FORM" && e.menuid !== 'fixcancel' && e.menuid !== 'print');
        }
        baseref.current.ChangeNavmenu(newmenu);
        baseref.current.hideMenucmd(hidemenu);
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        if (isEnabled(initializeRef.current)) return;   //APIコール済み
        initializeRef.current = true; 
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    var a = transinfo.current;
                    setpanel(data.panels);
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    fnc.current?.initMaster(data.master);

                    let idx = 0;
                    let glist = [];
                    data.panels.filter(e => e.grid).forEach(function (panel) {
                        gridapiRefs.current[idx] = createRef();
                        gridcolapiRefs.current[idx] = createRef();
                        griddataRefs.current[idx] = createRef();
                        gridcolRefs.current[idx] = createRef();
                        glist.push({ id: panel.id, type: panel.type, index: idx });
                        idx++;
                        let t = data.colinfo.find(e => e.logpid === "T" + panel.id)
                        if (!isEmpty(t)) {
                            //TOTAL用REF作成
                            gridapiRefs.current[idx] = createRef();
                            gridcolapiRefs.current[idx] = createRef();
                            griddataRefs.current[idx] = createRef();
                            gridcolRefs.current[idx] = createRef();
                            glist.push({ id: "T" + panel.id, type: t.type, index: idx });
                            idx++;
                        }
                    });

                    dispatch(setgridlist(glist));

                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    let key = search.split("key=")[1];
                    if (isEmpty(state) && !isEmpty(key)) {
                        let calldata = Loadstorage(key);
                        state = calldata?.state;  //他画面からの連携情報取得
                    }
                    locationstate.current = state;
                    transinfo.current = null;
                    if (!isEmpty(state)) {
                        transinfo.current = Object.assign({}, state);     //LIST情報保持
                        if (state.status !== "LIST") {
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        } else {
                            //作業・進捗管理から遷移
                            document.title += " <作業・進捗管理>";
                            baseref.current.ListExecute(true);
                        }
                    }
                    fnc.current?.wait(false);
                }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuinfo]);

    useEffect(() => {
        if (formstatus === "COPY FORM") {
            columninfo.filter(e => e.copyclear).forEach(function (col) {
                entrydataRef.current[col.columnid] = "";
            });

            rerender();
        }
    }, [formstatus]);

    //遷移state状態表示
    function TryCallShow() {
        if (isEmpty(locationstate.current)) {
            return;
        }
        let call = true;
        for (let i = 0; i < gridlist.length; i++) {
            if (EmptyPanel(gridlist[i].id, gridlist[i].type)) continue;
            if (isEmpty(GridApi(gridlist[i]))) {
                call = false; break;
            }
        }
        //遷移表示
        if (call) callshow();
    }
    function Transtype() {
        if (isEmpty(transinfo.current)) return TRANTYPE.NONE;
        if (transinfo.current.accepttype === "WorkProgMgr") return TRANTYPE.PROG;   //作業・進捗管理
        return TRANTYPE.NONE;
    }
    function QueryGetlist(param) {
        if (Transtype() !== TRANTYPE.PROG) return;
        //作業・進捗管理から遷移
        param.notshow = false;      //即時VIEW
        param.code = transinfo.current.keys;
        param.request = transinfo.current.accepttype;
    }

    function callshow() {
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code)
        } else {
            if (!isEmpty(locationstate.current.acceptinfo)) {
                AcceptAction();
            }
        }
        locationstate.current = null;   //最初の１度のみ
    }
    //受入処理
    function AcceptAction() {
        var state = locationstate.current;
        fnc.current.postaxios('deliverydtl/GetAccept', { type: state.accepttype,  "colinfo": columninfo, addinfo: [state.acceptinfo] },
            {
                onSuccess: function (data) {
                    try {
                        entrydataRef.current = data.data;
                        //行データ
                        var total = null;
                        for (let i = 0; i < gridlist.length; i++) {
                            if (data.detail[gridlist[i].type] !== null) {
                                SetGridData({ id: gridlist[i].id }, data.detail[gridlist[i].type]);
                                if (gridlist[i].id === G_id.RAW) {
                                    var rows = data.detail[gridlist[i].type];
                                    total = TotalCalc(G_id.RAW, data.detail[gridlist[i].type]);
                                }
                            }
                        }
                        if (total !== null) {
                            SetGridData({ id: G_id.TOTAL }, [{ rowid: "TOTAL", grip: "計", "QTY_T1": total.qty1, "QTY_T2": total.qty2, "QTY_T3": total.qty3, "QTY_T4": total.qty4 }]);
                        }
                        ApplySyusakiLayout();

                        setnavmenu(DicVal(entrydataRef.current, "NMD_FIXFLG", "") === '1' || DicVal(entrydataRef.current, "nosave", false), DicVal(entrydataRef.current, "CancelFix", false));   //NAVメニュの設定

                        rerender();
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
                },
                errmsg: "処理に失敗しました"
            }
        )
    }

    function cellHidden(columnids, hide) {
        var newhidden = hide ? '2' : '0';
        const updateColumns = (fields) => {
            if (isEmpty(fields) || !Array.isArray(columnids)) return fields;

            let changed = false;
            const newfields = DeepCopy(fields);

            newfields.forEach(field => {
                if (columnids.includes(field.columnid) && field.hidden !== newhidden) {
                    field.hidden = newhidden;
                    changed = true;
                }
            });

            return changed ? newfields : fields;
        };

        const nextTextFieldsAll = updateColumns(textfieldsall);
        const visibleKeys = new Set(
            textfields
                .filter(field => !columnids.includes(field.columnid) || !hide)
                .map(field => `${field.columnid}_${field.type}`)
        );

        if (!hide) {
            nextTextFieldsAll.forEach(field => {
                if (columnids.includes(field.columnid)) {
                    visibleKeys.add(`${field.columnid}_${field.type}`);
                }
            });
        }

        settextfieldsall(nextTextFieldsAll);
        settextfields(
            nextTextFieldsAll.filter(field =>
                field.hidden !== '2' && visibleKeys.has(`${field.columnid}_${field.type}`)
            )
        );
    }

    function onGridReady(param, id) {
        SetGridApi(id, param.api);
        SetGridColApi(id, param.api);

        TryCallShow();
    }

     function onFirstDataRendered(param, panel) {
    //     SetGridApi(panel, param.api);
    //     SetGridColApi(panel, param.api);

    //     if (!isEmpty(locationstate.current)) {
    //         let call = true;
    //         for (let i = 0; i < gridlist.length; i++) {
    //             if (EmptyPanel(gridlist[i].id, gridlist[i].type)) continue;
    //             if (isEmpty(GridApi(gridlist[i]))) {
    //                 call = false; break;
    //             }
    //         }
    //         //遷移表示
    //         if (call) callshow();
    //     }
    //     if (!isEmpty(entrydataRef.current)) {
    //         ApplySyusakiLayout();
    //     }
     }
    function Show(data, pushcode) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata", data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (isEmpty(columninfo)) return false;    //読み込み前
        clearform(code === "");
        //データ読み込み
        LoadData(code);
        return true;
    }

    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e => e.type !== type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
    }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try {
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        } catch { }
    }
    //行データ保持
    function storeRowData(panel) {
        if (panel === undefined) {
            for (let i = 0; i < gridlist.length; i++) {
                SetGridData(gridlist[i], AGRef.current.GetDatasource(GridApi(gridlist[i])));
            }
        } else {
            SetGridData(panel, AGRef.current.GetDatasource(GridApi(panel)));
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.NB) panelid = 'remarkspanel' + type;
        if (isEmpty(type)) {
            type = tabletype(id);
        }
        if (panel.some(e => e.id === id && e.type === type && e.grid)) {
            panelid = fnc.current.GridID({ id: id, type: type });
        }
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }


    function MenuAction(action, finallycallback) {
        LayoutSaveStorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") clearform(true);
        if (action === 'linkfield') {
            let col = textfields.find(e => e.columnid === finallycallback.field && (isEmpty(finallycallback.type) ? true : e.type === finallycallback.type));
            if (col === undefined) return;
            if (col.logpid == "0") {    //基本情報
                let key = finallycallback.field + "_" + col.type;
                document.getElementById(key).focus();
                document.getElementById(key).select();
                Jump(G_id.BASE, col.type);
                return;
            }
            let logpid = col.logpid;
            Jump(logpid);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, GridApi({ id: logpid }));
        }
        if (action === "fix") {     //確定
            let msg = "確定処理を行います。よろしいですか？";
            fnc.current.confmsg(msg, () => exec());
            function exec() {
                const paramdata = BuildEntryParamData(false);
                fnc.current.postaxios('deliverydtl/FixAction', paramdata,
                    {
                        onSuccess: function (data) {
                            fnc.current.modify(false);
                            const code = !isEmpty(data.request) ? data.request : edittingcode;
                            if (!isEmpty(code)) {
                                LoadData(code);
                            }
                            fnc.current.wait(false);
                        },
                        errmsg: "処理に失敗しました"
                    }
                )
            }
        }
        if (action === "fixcancel") {     //確定取消
            let msg = "確定取消処理を行います。よろしいですか？";
            fnc.current.confmsg(msg, () => exec());
            function exec() {
                const paramdata = BuildEntryParamData(false);
                fnc.current.postaxios('deliverydtl/CancelFix', paramdata,
                    {
                        onSuccess: function (data) {
                            fnc.current.modify(false);
                            const code = !isEmpty(data.request) ? data.request : edittingcode;
                            if (!isEmpty(code)) {
                                LoadData(code);
                            }
                            fnc.current.wait(false);
                        },
                        errmsg: "処理に失敗しました"
                    }
                )
            }
        }
        if (action === "print") {  //納品明細書発行
            let code = [];
            if (formstatus === "ENTRY FORM") {
                code = [edittingcode];
            } else {
                let param = baseref.current?.GetSelectrowdata();
                if (param.length === 0) {
                    fnc.current.warnmsg("対象データを選択してください");
                    return;
                }
                for (let i = 0; i < primarykeys.length; i++) {
                    if (primarykeys[i] in param[0]) {
                        for (let j = 0; j < param.length; j++) {
                            code.push(param[j][primarykeys[i]]);
                        }
                        break;
                    }
                }
            }
            if (code.length === 0) return;
            fnc.current.postaxios('NouhinMeiReport/Generate', { controller: controller, id: action, keys: code },
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
            return;
        }
    }
    function BuildEntryParamData(nocheck) {
        storeRowData();
        SetPLData();    //PL行データをentrydataRefにセット
        var detail = {};
        for (let i = 0; i < gridlist.length; i++) {
            if (gridlist[i].id === G_id.PL) continue;
            detail[gridlist[i].type] = GridData(gridlist[i].id);
        }

        return {
            "controller": formid,
            "data": entrydataRef.current,
            "detail": detail,
            "images": imageRef.current,
            "files": fileRef.current,
            "colinfo": columninfo,
            "code": edittingcode,
            "noconfirm": nocheck
        };
    }
    function Save(finallycallback, nocheck) {
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return;
        }
        const paramdata = BuildEntryParamData(nocheck);
        fnc.current.postaxios(formstatus === "ENTRY FORM" ? "deliverydtl/UpdateEntry" : "deliverydtl/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        let code = data.request;
                        if (formstatus !== "ENTRY FORM") {
                            let pkey = primarykey();
                            if (pkey !== "") entrydataRef.current[pkey] = data.request;
                            setedittingcode(data.request);
                            dispatch(changestatus("ENTRY FORM"));
                        }
                        if (newfiles.length !== 0) {        //v1.4
                            //新規ファイルアップロード
                            cfFileUpload("deliverydtl", code, newfiles, fnc, () => LoadData(code));
                        } else {
                            fnc.current.success();
                            if (formstatus === "ENTRY FORM") {
                                data.data['rowid'] = Getrowid();    //更新行キー
                                finallycallback(data.data);
                            }
                            LoadData(code);     //再表示
                        }
                    }
                    else {
                        if (!isEnabled(data.confirm)) {
                            //確認メッセージ
                            var msgs = ["内容を確認しそのまま登録する場合はOK,修正する場合はCancelを選択してください", "　"];
                            for (let i = 0; i < data.warning.length; i++) {
                                msgs.push("・" + data.warning[i].message);
                            }
                            fnc.current.confmsg(msgs, () => Save(finallycallback, true));
                        } else {
                            let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        )
    }
    function Delete(finallycallback) {
        const param = {
            rowdata: [{ "rowid": edittingcode }],
            controller: controller
        }
        fnc.current.postaxios("deliverydtl/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }
    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('deliverydtl/GetData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            //ViewからのMyField値を引継ぎ
                            let row = getglobaldata("entryrowdata");
                            if (!isEmpty(row)) {
                                let memo = nametocolumn("_memo");
                                if (memo !== "") {
                                    if (memo in row) data.data[memo] = row[memo];
                                }
                                let sticky = nametocolumn("_sticky");
                                if (sticky !== "") {
                                    if (sticky in row) data.data[sticky] = row[sticky];
                                }
                                let mytags = nametocolumn("_mytags");
                                if (mytags !== "") {
                                    if (mytags in row) data.data[mytags] = row[mytags];
                                }
                            }
                            fnc.current.margeMaster(data.master);
                            entrydataRef.current = data.data;
                            //行データ
                            var total = null;
                            for (let i = 0; i < gridlist.length; i++) {
                                if (data.detail[gridlist[i].type] !== null) {
                                    SetGridData({ id: gridlist[i].id }, data.detail[gridlist[i].type]);
                                    if (gridlist[i].id === G_id.RAW) {
                                        var rows = data.detail[gridlist[i].type];
                                        //残数セット ※残数＝入荷数で連携
                                        //残数はサーバー側で計算済み（以下の再計算ロジックをコメントアウト）
                                        //for (let i = 0; i < rows.length; i++) {
                                        //    if (DicVal(entrydataRef.current, "NMD_SYUSAKIKBN") === "4") {   //店直
                                        //        rows[i]["REMQTY"] = NumConv(rows[i]["SHDTH_HAIBUNSU"]) - NumConv(rows[i]["REMQTY"]);
                                        //    } else {
                                        //        rows[i]["REMQTY"] = NumConv(rows[i]["NMM_HACHUSU"]) - NumConv(rows[i]["REMQTY"]);
                                        //    }
                                        //}
                                        total = TotalCalc(G_id.RAW, data.detail[gridlist[i].type]);
                                    }
                                }
                            }
                            if (total !== null) {
                                SetGridData({ id: G_id.TOTAL }, [{ rowid: "TOTAL", grip: "計", "QTY_T1": total.qty1, "QTY_T2": total.qty2, "QTY_T3": total.qty3, "QTY_T4": total.qty4 }]);
                            }
                            if (!isEmpty(data.detail["120"])) {
                                entrydataRef.current["NMD_HACHUNO"] = data.detail["120"][0]["NMM_HACHUNO"];
                            }
                            ApplySyusakiLayout();

                            var a = textfieldsall;
                            gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
                                //PL行データ
                                SetGridData(l, fnc.current.PLRowData(data.data, l.type, columninfo));
                            });

                            setnavmenu(DicVal(entrydataRef.current, "NMD_FIXFLG", "") === '1' || DicVal(entrydataRef.current, "nosave", false), DicVal(entrydataRef.current, "CancelFix", false));   //NAVメニュの設定

                            if (Transtype() === TRANTYPE.PROG) {    //作業・進捗管理
                                var ids = ["NMD_DENYMD", "NMD_KENPINJOSUB", "NMD_TEKIYOU"];
                                changecelllock(ids, true);
                            }

                            //fileRef.current = data.files;
                            //imageRef.current = data.images;
                            //dispatch(setimagelist(data.images));
                            rerender();

                        }
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
                },
                onError: function (data) {
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                    fnc.current.wait(false);
                }
            }
        )
    }
    //編集ロック
    function changecelllock(columnids, locked) {
        const updateColumns = (fields) => {
            if (isEmpty(fields) || !Array.isArray(columnids)) return fields;

            let changed = false;
            const newfields = DeepCopy(fields);

            newfields.forEach(field => {
                if (columnids.includes(field.columnid) && field.locked !== locked) {
                    field.locked = locked;
                    changed = true;
                }
            });

            return changed ? newfields : fields;
        };

        settextfieldsall(prev => updateColumns(prev));
        settextfields(prev => updateColumns(prev));
    }

    function SetPLData() {
        gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
            let column = columninfo.find(e => e.type === l.type);
            if (!isEmpty(column)) {
                entrydataRef.current[column.columnid] = fnc.current.PLTextData(GridData(l), column.columnid);
            }
        });
    }
    //入力フィールドクリア
    function clearform(newform) {
        entrydataRef.current = initializedata(textfieldsall, staff);
        imageRef.current = null;
        fileRef.current = null;
        scrollRef.current = null;
        for (let i = 0; i < gridlist.length; i++) {
            SetGridData(gridlist[i], null);
        }

        dispatch(setimagelist([]));
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            var col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = initializedata(textfieldsall, staff);
                        rerender();
                    },
                }, true
            )
        }
    }
    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }

    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    //レイアウト保持
    function LayoutSaveStorage() {
        //列情報保存
        for (let i = 0; i < gridlist.length; i++) {
            AGRef.current.SaveColState(fnc.current.statusKey(gridlist[i].id, gridlist[i].type, formid), EmptyPanel(gridlist[i].id) ? null : GridColApi({ id: gridlist[i].id, type: gridlist[i].type }));
        }
        //基本情報保存
        Savestorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            if (panel[p].id === G_id.BASE) {
                if (setbase) break;
                let fds = textfields.filter(x => !x.hide);
                for (let f = 0; f < fds.length; f++) {
                    coldef.push({
                        headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                        type: fds[f].type
                    });
                }
                setbase = true;
            } else {
                cols = AGRef.current.GetshownColDef(GridColApi({ id: panel[p].id }));
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    for (let i = 0; i < gridlist.length; i++) {
                        var type = gridlist[i].type;
                        var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                        if (coldef.length === 0) continue;
                        SetGridColDef({ id: gridlist[i].id, type: gridlist[i].type }, coldef);
                    }
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {
        if (status === "INSERT") {
            //自テーブル以外編集不可
            if (tabvalue !== params.colDef.colinfo.type) return false;
        }
        return edit;
    }

    //パネル別列情報取得
    function tabletype(id) {
        let pnl = panel.find(e => e.id === id);
        if (isEmpty(pnl)) return '';
        return pnl.type;
    }
    //idに対する合計行が存在するか
    function existTotal(id) {
        return gridlist.some(e => e.id === "T" + id);
    }
    function TotalCalc(id, data) {
        if (id !== G_id.RAW) return null;
        if (isEmpty(entrydataRef.current)) return null;
        let total = { qty1: 0, qty2: 0, qty3: 0, qty4: 0 };
        for (let i = 0; i < data.length; i++) {
            if (DicVal(entrydataRef.current, "NMD_SYUSAKIKBN") === "4") {   //店直
                total.qty1 += NumConv(data[i]["NMM_HACHUSU"]);
                total.qty2 += NumConv(data[i]["SHDTH_HAIBUNSU"]);
                total.qty3 += NumConv(data[i]["REMQTY"]);
                total.qty4 += NumConv(data[i]["NMM_SYUKASU"]);
            } else {
                total.qty1 += NumConv(data[i]["NMM_LOT"]);
                total.qty2 += NumConv(data[i]["NMM_HACHUSU"]);
                total.qty3 += NumConv(data[i]["REMQTY"]);
                total.qty4 += NumConv(data[i]["NMM_SYUKASU"]);
            }
        }
        return total;
    }
    function SetTotalData(id, data) {
        var total = TotalCalc(id, data);
        if (total === null) return;
        let rowNode = GridApi("T" + id).getRowNode("TOTAL");
        if (!isEmpty(rowNode)) {
            rowNode.setDataValue('QTY_T1', total.qty1);
            rowNode.setDataValue('QTY_T2', total.qty2);
            rowNode.setDataValue('QTY_T3', total.qty3);
            rowNode.setDataValue('QTY_T4', total.qty4);
        }
    }

    function ChangeRowValue(params, panel) {
        SetTotalData(panel.id, GridData(panel));
    }

    //Basic Data Change
    function ValueChanged(id, value, edit) {
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
    }

    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }
    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.name}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} />
                ))}
            </ul>
        );
    });

    function Contents(props) {
        if (props.panel.id === G_id.BASE) {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.grid) {
            if (props.panel.id !== G_id.PL) {
                return (
                    <React.Fragment>
                        <EntryGridAr
                            id={fnc.current.GridID(props.panel)}
                            entrydataRef={entrydataRef}
                            dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                            columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                            columninfo={columninfo}
                            columns={columns}
                            fnc={fnc}
                            onGridReady={onGridReady}
                            onFirstDataRendered={onFirstDataRendered}
                            formid={formid}
                            ValueChanged={(e) => ChangeRowValue(e, props.panel)}
                            panel={props.panel}
                            AutoAddRow={false}
                            rowContext={1}

                        />
                        {!existTotal(props.panel.id) ? null :
                            <EntryGridAr
                                id={fnc.current.GridID("T" + props.panel.id)}
                                entrydataRef={entrydataRef}
                                dataRef={griddataRefs.current[fnc.current.gridindex("T" + props.panel.id)]}
                                columnRef={gridcolRefs.current[fnc.current.gridindex("T" + props.panel.id)]}
                                columninfo={columninfo}
                                columns={columns}
                                fnc={fnc}
                                onGridReady={onGridReady}
                                onFirstDataRendered={onFirstDataRendered}
                                formid={formid}
                                panel={props.panel}
                                total={true}
                                totaltype={tabletype("T" + props.panel.id)}
                            />
                        }
                    </React.Fragment>
                );
            } else {
                return (
                    <EntryGridAr
                        id={fnc.current.GridID(props.panel)}
                        entrydataRef={entrydataRef}
                        dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                        columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                        columninfo={columninfo}
                        columns={columns}
                        fnc={fnc}
                        onFirstDataRendered={onFirstDataRendered}
                        formid={formid}
                        ValueChanged={() => storeRowData(props.panel)}
                        panel={props.panel}
                        AutoAddRow={false}
                    />
                );
            }
        }
        if (props.panel.id === G_id.FILE) {
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.NB) {
            if (isEmpty(columninfo)) return null;
            let coldef = columninfo.find(e => e.type === props.panel.type);
            return (
                <EntryRemarks
                    id={"remarkspanel" + props.panel.type}
                    def={coldef}
                    dataRef={entrydataRef}
                    fnc={fnc}
                    ValueChanged={ValueChanged}
                />
            )
        }
        return null;

    }
    function EmptyPanel(id, type) {
        try {
            if (!panel.some(e => e.id === id)) return true; //パネル定義なし
            if (!isEmpty(type)) {
                if (!panel.some(e => e.id === id && e.type === type)) return true; //パネル定義なし
            }
            if (id === G_id.BASE) return isEmpty(textfields.find(e => e.type === type));
            let tbltype = tabletype(id);
            return !columns.some(e => e.type === tbltype);
        } catch { }
        return false;
    }
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }

    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom: '300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef} onDragEnter={onDragEnter}>
                {panel.map((p, i) => {
                    return (
                        <Box
                            key={`${p.id}-${p.type}-${i}`}
                            display={panelhidden(p) ? "none" : "flex"}
                            justifyContent="space-around"
                            alignItems="center"
                            padding="5px"
                        >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                            >
                                <div style={{ position: 'relative', marginBottom: 5 }}>
                                    {p.name} - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                    {p.id !== '0' || layoutlock ? null :
                                        <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                            <IconButton size="small" onClick={() => SetBaseField(p.type)}  >
                                                <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                    {layoutlock || sectionclose ? null :
                                        <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                            <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                                <Icon style={{ fontSize: 16 }}>close</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                </div>
                                <Contents panel={p} />
                            </Paper >
                        </Box>
                    );
                })}
            </div>
        );
    }
    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                ref={baseref }
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                entrycallback={MenuAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                suppressaction={suppressaction}
                primarykey={primarykeys}
                entrydataRef={entrydataRef}
                navmenu={navmenu}
                lockcell={ListlockCell}
                usecondition={true}
                querygetlist={QueryGetlist}
            >
                <EntryForm />
            </MasterBase>
            <EntryLayout
                columninfo={textfieldsall}
                textfields={textfields}
                onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} ></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                        <Paper
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                listStyle: 'none',
                                p: 0.5,
                                m: 0,
                            }}
                            component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                        >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                            />
                        </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
        </div>
    );
};
